// 关于我们
<template>
  <div style="background-color:white;">
	<header2/>
    <el-row type="flex" justify="center">
      <el-col :span="16" style="padding: 50px 17px 10px 17px;">
        <el-tabs type="border-card" tab-position="left" v-model="labelValue">
          <el-tab-pane name="aboutus">
            <span slot="label"><i class="el-icon-s-home"></i> 关于我们</span>
            
            <el-row type="flex" justify="left" style="margin-top: 30px;"><span class="line_title">关于我们</span><span class="line_title2">/About Us</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>泰盈科技集团股份有限公司主办的平台类网站客服帮，于2019年10月10日上线，总部位于山东泰安，主要服务有客服团队支持、智能云产品、云外呼平台、线路码号等。客服供应商和项目发包方可免费入驻平台，通过需求大厅寻找项目，寻找合作方。后期在系统中直接进行结算。</span></el-row>
            <!--<el-row type="flex" justify="left" class="line_content"><span>泰盈科技集团股份有限公司是中国呼叫中心及电商后台客服行业领跑者，与国内外互联网、电子商务、通信、金融、物流、制造业等行业中的近30家领先企业建立了战略合作关系。全面为合作企业提供客户服务整体解决方案、呼叫中心运营、电商后台运营、呼叫中心及电商后台人才服务、企业专业客服等核心服务。</span></el-row>

            <el-row type="flex" justify="left" style="margin-top: 20px;"><span class="line_title">企业战略：</span></el-row>
            <el-row type="flex" justify="left" class="line_content"><span>公司将秉承“创外包之泰、享服务之盈”的核心价值观，抓住国家对外开放和产业升级的历史机遇，加速全国互联网与电子商务后台基地、金融业后台处理基地、通信业后台处理基地、制造业后台处理基地的规模扩张，依托“泰盈云”战略，进一步提升核心竞争力，争做全球BPO行业领军企业。</span></el-row>

            <el-row type="flex" justify="left" style="margin-top: 20px;"><span class="line_title">公司荣誉：</span></el-row>
            <el-row type="flex" justify="left" class="line_content"><span>泰盈科技集团股份有限公司自成立以来，凭借可信赖的交付能力，在得到合作客户广泛赞誉的同时，也成为国家多部委和相关机构公认的BPO行业领军企业。</span></el-row>

            <el-row type="flex" justify="left" style="margin-top: 10px;"><span class="line_title" style="color: black;">获取荣誉</span></el-row>
            <el-row class="line_content">
              <div>1、中国信息技术服务产业联盟常务副理事长单位</div>
              <div>2、国家工信部中国呼叫中心与电商后台专委会理事长单位</div>
              <div>3、商务部“重点联络服务外包企业”</div>
              <div>4、国标委“呼叫中心服务标准化试点单位”</div>
              <div>5、中华全国中工会“模范职工小家”</div>
              <div>6、共青团中央“青年就业创业见习基地”</div>
              <div>7、中国呼叫中心与电子商务研究院“中国最佳客户中心”</div>
              <div>8、工信部软件与集成电路促进中心“中国最佳外包客户联络中心”</div>
            </el-row>

            <el-row type="flex" justify="left" style="margin-top: 10px;"><span class="line_title" style="color: black;">通过的认证</span></el-row>
            <el-row class="line_content">
              <div>1、高新技术企业</div>
              <div>2、双软企业</div>
              <div>3、ISO9001国际质量体系</div>
              <div>4、ISO27001国际信息安全体系</div>
            </el-row>-->

          </el-tab-pane>
          <el-tab-pane name="contactus">
            <span slot="label"><i class="el-icon-receiving"></i> 联系我们</span>
            <el-row type="flex" justify="left" style="margin-top: 30px;padding-bottom:200px;">
              <el-col :span="24" style="margin-right: 27px;">
                <el-col :span="16"><img src="../../assets/admin/addr.png"/></el-col>
                <el-col :span="8">
                  <el-row class="adv_title">泰盈科技集团股份有限公司</el-row>
                  <el-row class="adv_content" style="padding-left:10px;">电话：0538-6050058/6050055</el-row>
                  <el-row class="adv_content" style="padding-left:10px;">邮箱：taian@ccrc.com</el-row>
                  <el-row class="adv_content" style="padding-left:10px;">地址：泰安高新区中天门大街1366号</el-row>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
	<footer2/>
  </div>
</template>

<script>
  import header2 from '@/components/base/header2.vue'
  import footer2 from '@/components/base/footer2.vue'
  export default {
    data() {
      return {
        labelValue:this.$route.name
      }
    },
    mounted() {},
    created() {},
	components: {
	  header2,
	  footer2
	},
    computed: {},
    methods: {}
  }
</script>

<style scoped>
.line_title{
  color: #096FED;
  font-size: 16px;
  font-weight: bolder;
  display: inline-block;
  padding-left: 28px;
}
.line_title2{
  color: #b6b6b6;
  font-size: 14px;
  display: inline-block;
  padding: 4px 0px 0px 8px;
}
.line_content{
  font-size: 14px;
  line-height: 25px;
  margin-top: 15px;
  text-indent: 2em;
  text-align: left;
}
.adv_title{
  font-weight:bold;
  font-size:24px;
  text-align:left;
  padding-left:10px;
  padding-top:10px;
  margin-bottom: 20px;
}
.adv_content{
  font-size:14px;
  text-align:left;
  padding-left:10px;
  color:#8c9095;
  padding-top:10px;
}
</style>

<style>
.el-main{
  padding:0px;
}
</style>